import styled from 'styled-components'

const P = styled.p`
font-size: 1.8rem;
font-weight: 800px;
margin-block-end: 30px;
@media (min-width: 768px) {
  font-size: 2rem
}
`

export default P
